import gql from 'graphql-tag';

export const ACCOUNT_FLAGS_STATUS_FLAGS_QUERY = gql`
  query AccountFlagsStatusFlagsQuery($params: AccountStatusFlagsParams!) {
    statusFlags(params: $params) {
      name
      type
      token
    }
  }
`;
